'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { initMixpanel, trackCartillaViewed } from '@/lib/mixpanelClient';
import { isBrowserEnvironment } from '@/lib/browserUtils';

/**
 * Inicializa Mixpanel del lado del cliente y registra el ingreso a la cartilla
 * (evento cartilla_viewed) en cada cambio de ruta. Se monta una vez en el
 * layout raíz.
 */
export function MixPanelTracker() {
  const pathname = usePathname();

  useEffect(() => {
    if (!isBrowserEnvironment()) return;
    initMixpanel();
    trackCartillaViewed();
  }, [pathname]);

  return null;
}
